<div>

  <!-- Toolbar -->
  <div class="toolbar">
    
    <!-- Search -->
    <mat-form-field class="search-field">
      <input matInput type="text" (keyup)="search($event.target.value)" [placeholder]="'search' | translate: 'plural'">
    </mat-form-field>
  
    <!-- Reset filters -->
    <button mat-flat-button class="reset-filters" color="primary" (click)="tableFilterService.reset()" [disabled]="!(tableFilterService.active$ | async)">
      {{ 'clearFilters' | translate: 'plural' }}
    </button>
  </div>

  <!-- Table -->
  <table mat-table [dataSource]="elements" class="table-fixed table-status" matSort matSortActive="updated" matSortDirection="desc" matSortDisableClear>

    <!-- Code -->
    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'code' | translate }}</th>
      <td mat-cell *matCellDef="let element" (click)="log(element)">
        <div class="text-ellipsis">
          {{ element.code }}
        </div>
      </td>
    </ng-container>

    <!-- Name & value -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'name' | translate }} & {{ 'value' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <div class="text-ellipsis a">
          <strong (click)="goToElement(element)">{{ element.name }}</strong>
        </div>
        <sg2-element-value [element]="element"></sg2-element-value>
      </td>
    </ng-container>

    <!-- Construction name & type -->
    <ng-container matColumnDef="customValues.constructionName">
      <th mat-header-cell *matHeaderCellDef>
        <mat-icon [class.active]="(tableFilterService.filtersMap$ | async)['construction']"
          [inline]="true"
          (click)="tableFilterService.showFiltersFor('construction')">sort</mat-icon>
        <span class="sort-area" mat-sort-header arrowPosition="after">{{ 'construction' | translate}}</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <!-- Add link to construction
        <div class="text-ellipsis a" (click)="goToConstruction(element)">
          {{ element.customValues.constructionName }}
        </div> -->
        <div class="text-ellipsis">
          {{ element.customValues.constructionName }}
        </div>
        <div class="text-ellipsis row-line-sub line-height-increase">
          <small><em>{{ element.customValues.constructionType | translate }}</em></small>
        </div>
      </td>
    </ng-container>

    <!-- Module & submodule -->
    <ng-container matColumnDef="customValues.moduleName">
      <th mat-header-cell *matHeaderCellDef>
        <mat-icon [class.active]="(tableFilterService.filtersMap$ | async)['chapter']"
          [inline]="true"
          (click)="tableFilterService.showFiltersFor('chapter')">sort</mat-icon>
        <span class="sort-area" mat-sort-header arrowPosition="after">{{ 'module' | translate }} & {{ 'submodule' | translate }}</span>
      </th>
      <td mat-cell *matCellDef="let element"><div>
        <div class="text-ellipsis">
          {{ element.customValues.moduleName }}
        </div>
        <div class="text-ellipsis row-line-sub line-height-increase">
          <small><em>{{ element.customValues.submoduleName }}</em></small>
        </div>
      </div></td>
    </ng-container>
    
    <!-- Assigned to user -->
    <ng-container matColumnDef="customValues.userName">
      <th mat-header-cell *matHeaderCellDef>
        <mat-icon [class.active]="(tableFilterService.filtersMap$ | async)['user']"
          [inline]="true"
          (click)="tableFilterService.showFiltersFor('user')">sort</mat-icon>
        <span class="sort-area" mat-sort-header arrowPosition="after">{{ 'assign' | translate }}</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="text-ellipsis" [class.muted]="!element.customValues.userName">
          <sg2-element-assign-to [element]="element"></sg2-element-assign-to>
        </div>

        <div class="text-ellipsis row-line-sub line-height-decrease">

          <span [ngSwitch]="element.commentCount">
            <div *ngSwitchCase="0 || undefined" class="a muted" (click)="sidebarService.open(element, 'logs')">
              <small><em>{{ 'noComment' | translate }}</em></small>
            </div>
            <div *ngSwitchCase="1" class="a" (click)="sidebarService.open(element, 'logs')">
              <small><em>
                <mat-icon [inline]="true">comment</mat-icon>
                1 {{ 'comment' | translate | lowercase }}
              </em></small>
            </div>
            <div *ngSwitchDefault class="a" (click)="sidebarService.open(element, 'logs')">
              <small><em>
                <mat-icon [inline]="true">comment</mat-icon>
                {{ element.commentCount }} {{ 'comment' | translate: 'plural' | lowercase }}
              </em></small>
            </div>
          </span>

        </div>
      </td>
    </ng-container>

    <!-- Status & Last edited -->
    <ng-container matColumnDef="edited">
      <th mat-header-cell *matHeaderCellDef>
        <mat-icon [class.active]="(tableFilterService.filtersMap$ | async)['status']"
          [inline]="true"
          (click)="tableFilterService.showFiltersFor('status')">sort</mat-icon>
        <span class="sort-area" mat-sort-header arrowPosition="after">{{ 'status' | translate }}</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="text-ellipsis">
          <sg2-element-status [element]="element"></sg2-element-status>
        </div>
        <div class="text-ellipsis muted row-line-sub line-height-decrease"
          [matTooltip]="( element.updated | date: 'dd-MM-yyyy HH.mm' )"
          matTooltipPosition="above">
          <small><em>{{ element.updated | dateAgo }}</em></small>
        </div>
      </td>
    </ng-container>

    <!-- Options -->
    <ng-container matColumnDef="options">
      <th mat-header-cell *matHeaderCellDef>{{ 'option' | translate: 'plural' }}</th>
      <td mat-cell *matCellDef="let element">
        <sg2-element-options [element]="element"></sg2-element-options>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns; let element"
      [id]="element._id"
      [ngStyle]="{
        'border-left': '5px solid ' +  ( element.status | status: '_id': 'color' )
      }">
    </tr>
  </table>

  <mat-paginator #paginator [pageSizeOptions]="[25, 50, 100]" (page)="onChangePage($event)" showFirstLastButtons></mat-paginator>
</div>
